import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import HeroFR from '../components/fr/HeroFR';
import ProblemSolutionFR from '../components/fr/ProblemSolutionFR';
import ProcessFR from '../components/fr/ProcessFR';
import ProductShowcaseFR from '../components/fr/ProductShowcaseFR';
import ROICalculatorPricing from '../components/ROICalculatorPricing';
import FAQFR from '../components/fr/FAQFR';
import FooterFR from '../components/fr/FooterFR';

/**
 * French landing page for real estate photographers and partners.
 * Navbar: Tarifs, Calculateur ROI, Portfolio, FAQ, Connexion, S'inscrire.
 * ROI Calculator included. Pricing in €. Unused credits valid 6 months.
 */
const PageFRPartenaires: React.FC = () => {
  const [activeProfileId, setActiveProfileId] = useState<'matterport-only' | 'matterport-drone'>('matterport-only');

  return (
    <motion.div
      className="min-h-screen bg-gradient-to-b from-white to-[#3C59B2]/10"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Header />
      <HeroFR variant="partenaires" />
      <ProblemSolutionFR variant="partenaires" activeProfileId={activeProfileId} onProfileChange={setActiveProfileId} />
      <ProcessFR variant="partenaires" />
      <ProductShowcaseFR variant="partenaires" activeProfileId={activeProfileId} />
      <ROICalculatorPricing
        showRoiCalculator={true}
        currency="eur"
        locale="fr"
        signupPath="/fr/partenaires/signup"
        partnerMode
      />
      <FAQFR variant="partenaires" />
      <FooterFR showRoiLink variant="partenaires" />
    </motion.div>
  );
};

export default PageFRPartenaires;
